import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import ArticleCard from "../common/articleCard/ArticleCard.common";
import Title from "../common/title/Title.common";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";
import ActivityIndicator from "../hoc/activityIndicator/ActivityIndicator.hoc";

// ACTIONs
import { useDispatch, useSelector } from "react-redux";
import { getBookletAction } from "../../actions/Actions";

const BookletPage = (props) => {
  const { setHeaderTitle, language } = useAuth();
  const dispatch = useDispatch();
  const { listLoader, list } = useSelector((state) => state.booklet);

  useEffect(() => {
    setHeaderTitle(language.key.publication);
  }, [setHeaderTitle, language.key.publication]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getBookletAction());
  }, [getBookletAction]);

  return (
    <CompWrapper>
      <Title title="Booklet" hide_SeeAll />
      <ActivityIndicator animating={listLoader}>
        {list.length > 0 ? (
          <div className="news-container">
            {list.map((val, index) => {
              return (
                <div key={index}>
                  <ArticleCard data={val} />
                </div>
              );
            })}
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No Data Available</p>
        )}
      </ActivityIndicator>
    </CompWrapper>
  );
};
export default BookletPage;
